/**
 * Groups a collection of objects that share a common property by the values set for that property
 * @param entities Array of objects with a common `key` property
 * @param key A key to group by
 * @returns A dictionary of objects
 */
const keyBy = <
  T extends { [key in K]: string | number | symbol },
  K extends string | number | symbol
>(
  entities: T[],
  key: K
): Partial<Record<T[K], T>> =>
  entities.reduce<Partial<Record<T[K], T>>>((dictionary, entity) => {
    dictionary[entity[key]] = entity;
    return dictionary;
  }, {});

export default keyBy;
